module.exports = __webpack_public_path__ + "img/conciliation-inventaire-2-petit.e441ff3e.jpeg";